import VideoModal from '../components/common/modal/video-modal'
import Grid from '../components/grid'
import Button from '../components/ui/button'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'watch-video-cta' }>

export default function WatchVideoCTA(block: BlockProps): ReactElement {
  const [showModal, setShowModal] = React.useState(false)

  const { title, description, url = 'https://www.youtube.com/embed/sjkiw7OYbVY', options } = block
  return (
    <Container>
      <VideoModal showModal={showModal} setShowModal={setShowModal} title={title} url={url} />
      <div className="relative bg-black p-8 md:p-12 lg:p-20 flex flex-col justify-center items-center">
        <Asset
          resource={options?.image as AssetType}
          imgClassName="object-cover object-center opacity-50"
          fill
        />
        <Grid className="z-10 gap-8">
          <div className="col-span-4">
            <Text variant="mediumHeading" className="text-white">
              {title}
            </Text>
          </div>

          <div className="col-span-4 pb-4 border-b border-white">
            <Text variant="body" className="text-white">
              {description}
            </Text>
          </div>

          <div className="col-span-4 flex items-end">
            <Button
              type="button"
              onClick={() => setShowModal(true)}
              className="w-full text-white hover:border-black"
              variant="flatLight"
              invert={true}
            >
              Watch Video
            </Button>
          </div>
        </Grid>
      </div>
    </Container>
  )
}
